"use client"

import classNames from "classnames"
import styles from "../../../styles/LandingPage/Patients.module.scss"
import StyledText from "../../typography/typography-component"
import skColors from "../../../styles/skColors"
import Profile from "../LandingPage/profile/Profile"
import SText from "../Text/SText"
import Button from "../Button/Button"
import { useTranslations } from "next-intl"

const DiseasesInformationSection = (props: { onClick: () => void }) => {
  const t = useTranslations("index")

  return (
    <div className={classNames(styles.diseasesContainer)} style={{ backgroundColor: skColors.orange[100] }}>
      <div className={styles.diseaseTitle}>
        <StyledText color={skColors.turquoise[600]} variant={"h2"}>
          {t("conditions.title")}
        </StyledText>
        <StyledText variant={"h3"}>{t("conditions.description")}</StyledText>
      </div>

      <div className={styles.diseaseElementsContainer}>
        {/* Psoriasis */}
        <div style={{ minWidth: "200px" }} className={classNames(styles.col, styles.itemsCenter)}>
          <Profile
            href={"https://www.gesundheitsinformation.de/schuppenflechte-psoriasis.html"}
            alt={t("conditions.items.psoriasis.title")}
            src={"/images/skin_conditions/psoriasis.webp"}
          />
          <StyledText
            className={styles.tagFontSize}
            style={{ marginBottom: "6px" }}
            variant={"tags"}
            color={skColors.turquoise[600]}
          >
            {/* render title + subtitle inline */}
            {t("conditions.items.psoriasis.title")}
          </StyledText>
          <SText as="span" variant={"body"} size={16} color={"green500"} style={{ marginLeft: 6 }}>
            {`(${t("conditions.items.psoriasis.subtitle")})`}
          </SText>
        </div>

        {/* Atopic dermatitis */}
        <div style={{ minWidth: "200px" }} className={classNames(styles.col, styles.itemsCenter)}>
          <Profile
            href={"https://www.gesundheitsinformation.de/neurodermitis-atopisches-ekzem.html"}
            alt={t("conditions.items.dermatitis.title")}
            src={"/images/skin_conditions/atopic_dermatitis.webp"}
          />
          <StyledText
            className={styles.tagFontSize}
            style={{ marginBottom: "6px" }}
            variant={"tags"}
            color={skColors.turquoise[600]}
          >
            {t("conditions.items.dermatitis.title")}
          </StyledText>
          <SText as="span" variant={"body"} size={16} color={"green500"} style={{ marginLeft: 6 }}>
            {`(${t("conditions.items.dermatitis.subtitle")})`}
          </SText>
        </div>

        {/* Hand eczema */}
        <div style={{ minWidth: "200px" }} className={classNames(styles.col, styles.itemsCenter)}>
          <Profile
            href={"https://gesund.bund.de/dyshidrotisches-ekzem"}
            alt={t("conditions.items.handEczema.title")}
            src={"/images/skin_conditions/hand_eczema.webp"}
          />
          <SText style={{ marginBottom: "6px" }} variant={"body"} size={16} color={"turq500"}>
            {t("conditions.items.handEczema.title")}
          </SText>
          <SText variant={"body"} size={16} color={"green500"}>
            {t("conditions.items.handEczema.subtitle")}
          </SText>
        </div>
      </div>

      <Button hug onClick={props.onClick} variant={"primary"}>
        {t("conditions.cta")}
      </Button>
    </div>
  )
}
export default DiseasesInformationSection
